import { Collection } from "@type-r/models";
import React from "react";
import { UnresolvedGroupInfo } from "../common";
import { PaymentOpenItems } from "../../common/open-items";

export const PendingUnresolvedPayments = ({payments}:{payments: Collection<UnresolvedGroupInfo>}) => {

    const unresolvedPaymentsTotalCount = payments.reduce((curr:number, sum) => curr + sum.count, 0)

    return (<PaymentOpenItems title={`Open Items - (${unresolvedPaymentsTotalCount})`}
                payments={payments}
                linkUrl='inmatch/bank-transactions/unresolved'
                type='unresolved-payments'/>
    );
}
